<template>
  <path
    d="M7 19.0002H17C17.55 19.0002 18 19.4502 18 20.0002C18 20.5502 17.55 21.0002 17 21.0002H7C6.45 21.0002 6 20.5502 6 20.0002C6 19.4502 6.45 19.0002 7 19.0002Z"
  />
</template>
